// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__2bMtd{
    width:100vw;
    height:100vh;
    display:flex;
    justify-content: center;
    align-items:center
}
.styles_content__T\\+edS{
    width:auto;
    height:auto;
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items:center
}
.styles_content__T\\+edS p{
    margin:20px;
    /* margin-top:40px; */
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Splash/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB;AACJ;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B;AACJ;AACA;IACI,WAAW;IACX,qBAAqB;AACzB","sourcesContent":[".container{\n    width:100vw;\n    height:100vh;\n    display:flex;\n    justify-content: center;\n    align-items:center\n}\n.content{\n    width:auto;\n    height:auto;\n    display:flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items:center\n}\n.content p{\n    margin:20px;\n    /* margin-top:40px; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__2bMtd`,
	"content": `styles_content__T+edS`
};
export default ___CSS_LOADER_EXPORT___;
